import { render, staticRenderFns } from "./upload-clients.vue?vue&type=template&id=d642f96a"
import script from "./upload-clients.vue?vue&type=script&lang=js"
export * from "./upload-clients.vue?vue&type=script&lang=js"
import style0 from "./upload-clients.vue?vue&type=style&index=0&id=d642f96a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports